import React from 'react'
import './Hobbies.css'
const Hobbies = ({darkMode}) => {
  return (
    <div id='Hobbies'className={`${darkMode ? "dark-mode-portfolio" : ""}`}>
      <h3>Hobbies</h3> 
     developer is sleeping now.
      <br />
      (coming soon..............)
     
    </div>
  )
}

export default Hobbies
